export default __webpack_public_path__ + "static/media/qms_back_btn.0e518dc3.svg";